var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import { Box, Button, Flex, FormField, Spinner, Text } from 'pcln-design-system';
import { FormInput } from '../OtpForm/OtpForm.styles';
import { useOtpContext } from '../../context/OtpContext';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import ResendButton from './ResentButton';
import { ErrorToolTip } from '../OtpForm/OtpForm.styles';
const VerificationCode = () => {
  const messageEndRef = useRef(null);
  const errorMessage = 'I’m having some trouble accessing your trip information. ';
  const [showVerificationError, setShowVerificationError] = useState(false);
  const [validOtpCode, setValidOtpCode] = useState(false);
  const [smsCode, setSmsCode] = useState();
  const {
    verificationApiFunction,
    setOtpRequestErrorMsg,
    handleOtpSubmit,
    resendInProgress
  } = useOtpContext();
  const [otpValidationInProgress, setOtpValidationInProgress] = useState(false);
  const {
    setAccountLessAccessToken
  } = useContext(ChatbotDataContext);
  useEffect(() => {
    var _a;
    (_a = messageEndRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
      behavior: 'smooth'
    });
  }, []);
  const isSmsCodeValidated = useMemo(() => {
    return smsCode && /^\d{6}$/.test(String(smsCode));
  }, [smsCode]);
  const disableButton = useMemo(() => {
    return !(smsCode && isSmsCodeValidated);
  }, [smsCode, isSmsCodeValidated]);
  function handleSmsCodeChange(e) {
    const value = e.currentTarget.value;
    setShowVerificationError(false);
    // Only allow up to 6 digits
    if (/^\d*$/.test(value) && value.length <= 6) {
      setSmsCode(value);
    }
  }
  function submitFormHandler(e) {
    return __awaiter(this, void 0, void 0, function* () {
      e.preventDefault();
      setOtpRequestErrorMsg('');
      setOtpValidationInProgress(true);
      try {
        const verificationResult = yield verificationApiFunction(smsCode);
        if (verificationResult.success) {
          setValidOtpCode(true);
          setAccountLessAccessToken(verificationResult.token);
          handleOtpSubmit(verificationResult.token);
        } else {
          setShowVerificationError(true);
        }
      } catch (e) {
        setOtpRequestErrorMsg(errorMessage);
      } finally {
        setOtpValidationInProgress(false);
      }
    });
  }
  return React.createElement(React.Fragment, null, otpValidationInProgress ? React.createElement(Spinner, null) : validOtpCode ? React.createElement(Text, {
    fontWeight: 'bold'
  }, "Success!") : !resendInProgress ? React.createElement(Box, null, React.createElement(Flex, {
    flexDirection: 'column',
    pb: 2
  }, React.createElement(Box, null, showVerificationError ? React.createElement(ErrorToolTip, {
    id: 'otp-verification-error',
    right: true,
    top: true,
    color: 'error'
  }, "It looks like that code isn\u2019t working. It may have expired or been entered incorrectly. Please try again.") : null, React.createElement(FormField, null, React.createElement(FormInput, {
    id: 'code',
    name: 'phone',
    type: 'text',
    inputMode: 'numeric',
    pattern: '[0-9]{6}',
    maxLength: 6,
    placeholder: '6-digit code \u207A',
    onChange: handleSmsCodeChange,
    value: smsCode
  })))), React.createElement(Box, null, React.createElement(Button, {
    disabled: disableButton,
    onClick: submitFormHandler
  }, "Confirm"))) : null, !otpValidationInProgress && React.createElement(ResendButton, {
    validOtpCode: validOtpCode
  }));
};
export default VerificationCode;